<div class="dialog-header">
  <h2 mat-dialog-title class="clickable" (click)="openAssetDetails()">
    <a>{{(assetName$ | async)?.name | traceableFormat}}</a>
    @if ((isArchived$ | async)) {
      <mat-chip
        style="margin-left: 10px"
        class="archived"
        [disableRipple]="true"
        matTooltip="{{archivedDate$ | async | date}}">
        <mat-icon matChipAvatar>inventory_2</mat-icon>
        <span>Archived</span>
      </mat-chip>
    }
  </h2>
  <button mat-icon-button (click)="closeDialog()" class="dialog-close" aria-label="Close" data-test="dialog-close">
    <mat-icon>close</mat-icon>
  </button>
</div>
@if (isCloseDisabled) {
  <valumize-info-panel [appearance]="'WARNING'"
  [message]="'There are unsaved changes. Please exit the edit mode by saving or cancelling to return to the fund overview.'"></valumize-info-panel>
}
@if (isAssetDetailsDisabledInfo) {
  <valumize-info-panel [appearance]="'WARNING'"
  [message]="'There are unsaved changes. Please exit the edit mode by saving or cancelling to go to the company details.'"></valumize-info-panel>
}
<mat-dialog-content>
  <mat-accordion multi>
    <mat-expansion-panel [expanded]="expanded === assetDialogExpandType.GENERAL">
      <mat-expansion-panel-header>
        <mat-panel-title>General Information</mat-panel-title>
      </mat-expansion-panel-header>
      <valumize-asset-general-information></valumize-asset-general-information>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="expanded === assetDialogExpandType.GPVALUATION || expanded === assetDialogExpandType.PURCHASEMULTIPLES">
      <mat-expansion-panel-header>
        <mat-panel-title>GP Valuation</mat-panel-title>
      </mat-expansion-panel-header>
      <valumize-asset-gp-valuation></valumize-asset-gp-valuation>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="expanded === assetDialogExpandType.EXITINFO">
      <mat-expansion-panel-header>
        <mat-panel-title>Investment & Exit Dates</mat-panel-title>
      </mat-expansion-panel-header>
      <valumize-asset-exit-information></valumize-asset-exit-information>
    </mat-expansion-panel>
    @if ((sourceDataset$ | async) === 'master') {
      <mat-expansion-panel [expanded]="expanded === assetDialogExpandType.VALUATION || expanded === assetDialogExpandType.PURCHASEMULTIPLES">
        <mat-expansion-panel-header>
          <mat-panel-title>Company Valuation (Forecast)</mat-panel-title>
        </mat-expansion-panel-header>
        @if (preferredValuationType === valuationTypeEnum.DiscountMultipleValuation) {
          <valumize-asset-discount-multiple-valuation></valumize-asset-discount-multiple-valuation>
        } @else {
          <valumize-asset-financial-operational-valuation [assetId]="assetId"></valumize-asset-financial-operational-valuation>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button (click)="openAssetDetails()"
    data-test="company-details-button"
    mat-stroked-button>
    <mat-icon>factory</mat-icon>
    Company Details
  </button>
</mat-dialog-actions>
